/*
 * File: page-template-list.component.ts                                       *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 1st June 2022 13:49:45                             *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';

import { PageTemplate } from '@nousmedis/cc-types';
import { PageTemplateService } from '../../../services/page-template.service';
import { UserService } from '../../../../user/services/user.service';

import { User } from '@nousmedis/guard-types/dist/frontend';

import { AuthModel } from '@nousmedis/nm-guard-auth';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageTemplateInuse } from 'app/modules/catalog-cloud/interfaces/page-template-inuse.interface';

@Component({
  selector: 'app-page-template-list',
  templateUrl: './page-template-list.component.html',
  styleUrls: ['./page-template-list.component.scss'],
})
export class PageTemplateListComponent implements OnInit {
  dataTable: PageTemplate[] = [];
  loading: boolean = true;
  displayedColumns = ['name', 'columns', 'rows', 'actions'];
  displayDialog: boolean = false;
  showImportDialog = false;
  templateInuse: PageTemplateInuse[];
  checkModifiedTempaltes: Subscription;
  user: User;
  constructor (
    private auth: AuthModel,
    private pageTemplateService: PageTemplateService,
    private confirmDialog: ConfirmationService,
    private userService: UserService,
    private translateService: TranslateService,
    private router: Router,
  ) {
    this.user = this.auth.getCurrentUser();
  }

  // @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {

    this.subscriptions();
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.pageTemplateService.getTemplates().subscribe((data) => {
      this.dataTable = data;
      this.loading = false;
    });

  }

  editTemplate(id: string) {
    this.router.navigate(['/page-templates', id]);
  }

  cloneTemplate(id: string) {
    this.pageTemplateService.cloneTemplate(this.user.id, id);
  }

  async removeTemplate(id: string) {
    this.templateInuse = await firstValueFrom(this.pageTemplateService.pageTemplateIsInUse(id));
    

    //si el array devuelto es 0 entonces se podra eliminar
    if( this.templateInuse.length === 0){
      this.confirmDialog.confirm({
        message: this.translateService.instant('PAGE.SURE_DELETE_TEMPLATE'),
        key: 'pageTemplateConfirm',
        acceptLabel: this.translateService.instant('FORM.YES'),
        rejectLabel: 'No',
        accept: () => {
          this.pageTemplateService.removeTemplate(id);
        },
        'header': this.translateService.instant('PAGE.DELETE_TEMPLATE'),
        'reject': () => { }
      });
    }else{
      this.displayDialog = true;
    }
  }
  
  closeDialog() {
    this.displayDialog = false;
    this.templateInuse = [];
  }
  subscriptions() {
    this.checkModifiedTempaltes =
      this.pageTemplateService.templatesModified.subscribe((data) => {
        this.loadData();
      });
  }

  createTemplate() {
    this.router.navigate(['/page-templates/new']);
  }

  exportTemplate(id: string, name: string) {
    this.pageTemplateService.exportTemplate(id).subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `page-template-${name}.json`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  openImportDialog() {
    this.showImportDialog = true;
  }

  onTemplateImported(template: any) {
    this.loadData();
  }

}
